WL.registerComponent('cryometer-controller', {
    cry0Material: { type: WL.Type.Material },
    cry1Material: { type: WL.Type.Material },
    cry2Material: { type: WL.Type.Material },
    cry3Material: { type: WL.Type.Material },
    cry4Material: { type: WL.Type.Material },
    cry5Material: { type: WL.Type.Material },
}, {
    start: function () {
        this.cryometerMesh = this.object.getComponent('mesh');
        this.cryometerMesh.material = this.cry0Material;
        window.SW.gameState.cryingKidsSubject.subscribe(lives => {
            switch (lives) {
                case 0:
                    this.cryometerMesh.material = this.cry0Material;
                    break;
                case 1:
                    setTimeout(() => {
                        this.cryometerMesh.material = this.cry1Material;
                        window.SW.soundEffects.playSound(Sounds.buzz);
                    }, 1500);
                    break;
                case 2:
                    setTimeout(() => {
                        this.cryometerMesh.material = this.cry2Material;
                        window.SW.soundEffects.playSound(Sounds.buzz);
                    }, 1500);
                    break;
                case 3:
                    setTimeout(() => {
                        this.cryometerMesh.material = this.cry3Material;
                        window.SW.soundEffects.playSound(Sounds.buzz);
                    }, 1500);
                    break;
                case 4:
                    setTimeout(() => {
                        this.cryometerMesh.material = this.cry4Material;
                        window.SW.soundEffects.playSound(Sounds.buzz);
                    }, 1500);
                    break;
                case 5:
                    setTimeout(() => {
                        this.cryometerMesh.material = this.cry5Material;
                        window.SW.soundEffects.playSound(Sounds.buzz);
                    }, 1500);
                    break;
            }
        });
    },
});
